"use strict";

exports.__esModule = true;
exports.default = _default;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var timeout = null;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      position: 'relative',
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      flex: 1,
      borderRadius: 4,
      minHeight: 48,
      display: 'block',
      '&:hover': {
        background: (0, _colorManipulator.alpha)(theme.palette.common.white, 0.25)
      },
      '& $input': {
        transition: theme.transitions.create('width'),
        width: 0,
        '&:focus': {
          width: 240
        }
      }
    },
    rootOpen: {
      fontFamily: theme.typography.fontFamily,
      position: 'relative',
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      flex: 1,
      borderRadius: 4,
      minHeight: 48,
      display: 'block',
      background: (0, _colorManipulator.alpha)(theme.palette.common.white, 0.25),
      width: 240
    },
    search: {
      width: theme.spacing(1) * 5,
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    input: {
      font: 'inherit',
      padding: theme.spacing(1) * 2 + "px 0px 0px " + theme.spacing(1) * 5 + "px",
      border: 0,
      display: 'block',
      verticalAlign: 'middle',
      whiteSpace: 'normal',
      background: 'none',
      margin: 0,
      // Reset for Safari
      color: 'inherit',
      width: '100%',
      '&:focus': {
        outline: 0
      }
    },
    inputOpen: {
      font: 'inherit',
      padding: theme.spacing(1) * 2 + "px 0px 0px " + theme.spacing(1) * 5 + "px",
      border: 0,
      display: 'block',
      verticalAlign: 'middle',
      whiteSpace: 'normal',
      background: 'none',
      margin: 0,
      // Reset for Safari
      color: 'inherit',
      width: '100%',
      outline: 0
    }
  };
});

function _default(_ref) {
  var onChange = _ref.onChange,
      _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === void 0 ? '' : _ref$initialValue,
      alwaysOpen = _ref.alwaysOpen,
      _ref$deferTime = _ref.deferTime,
      deferTime = _ref$deferTime === void 0 ? 1000 : _ref$deferTime;
  var classes = useStyles();

  var _useState = (0, _react.useState)(''),
      value = _useState[0],
      setValue = _useState[1];

  (0, _react.useEffect)(function () {
    setValue(initialValue); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var hasValue = value && value !== '';
  var isOpen = hasValue || alwaysOpen;

  var handleChange = function handleChange(v) {
    if (timeout) {
      clearTimeout(timeout);
    }

    setValue(v);
    timeout = setTimeout(function () {
      if (onChange) {
        onChange(v);
      }
    }, deferTime);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: isOpen ? classes.rootOpen : classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.search
  }, /*#__PURE__*/_react.default.createElement(_Search.default, null)), /*#__PURE__*/_react.default.createElement("input", {
    autoComplete: "off",
    id: "search-input",
    value: value,
    ref: function ref(node) {
      if (node && initialValue && initialValue !== '') {
        node.focus();
      }
    },
    className: isOpen ? classes.inputOpen : classes.input,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    }
  }));
}

module.exports = exports.default;